import { CurrencyCode } from "#graphql/supergraphEnums";

/**
 * Each country's primary currency, keyed by ISO alpha-2 code. Used to default
 * the currency selector when a country is chosen; the user can still override
 * it, because a bank in one country can hold an account denominated in another.
 *
 * Countries absent from this map leave the currency untouched (blank until the
 * user picks one) rather than guessing.
 */
const PRIMARY_CURRENCY_BY_COUNTRY: Readonly<Record<string, CurrencyCode>> = {
  US: CurrencyCode.Usd,
  GB: CurrencyCode.Gbp,
  AU: CurrencyCode.Aud,
  CA: CurrencyCode.Cad,
  NZ: CurrencyCode.Nzd,
  CH: CurrencyCode.Chf,
  JP: CurrencyCode.Jpy,
  SE: CurrencyCode.Sek,
  NO: CurrencyCode.Nok,
  DK: CurrencyCode.Dkk,
  SG: CurrencyCode.Sgd,
  HK: CurrencyCode.Hkd,
  IN: CurrencyCode.Inr,
  ZA: CurrencyCode.Zar,
  MX: CurrencyCode.Mxn,
  BR: CurrencyCode.Brl,
  // Eurozone members that use the euro.
  AT: CurrencyCode.Eur,
  BE: CurrencyCode.Eur,
  DE: CurrencyCode.Eur,
  ES: CurrencyCode.Eur,
  FI: CurrencyCode.Eur,
  FR: CurrencyCode.Eur,
  GR: CurrencyCode.Eur,
  IE: CurrencyCode.Eur,
  IT: CurrencyCode.Eur,
  LU: CurrencyCode.Eur,
  NL: CurrencyCode.Eur,
  PT: CurrencyCode.Eur,
};

/**
 * The primary currency for a country's alpha-2 code, or `undefined` when the
 * country is not mapped.
 */
export const defaultCurrencyForCountry = (country?: string): CurrencyCode | undefined =>
  country ? PRIMARY_CURRENCY_BY_COUNTRY[country] : undefined;
